import { render, staticRenderFns } from "./DeliveryAddressChange.vue?vue&type=template&id=62850c68&"
import script from "./DeliveryAddressChange.vue?vue&type=script&lang=ts&"
export * from "./DeliveryAddressChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports